import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalStorageService } from './infrastructure/local-storage.service';
import { LocalStorageKeysEnum } from '../utils/enums';
import { Store } from '@ngxs/store';
import { IUserGeolocation } from '@app/core';
import { AppStoreActions } from '../store/app.store.actions';

@Injectable({
  providedIn: 'root'
})
export class UserGeolocationService {

  constructor(
    private store: Store,
    private localStorage: LocalStorageService
  ) {



    // this.userGeolocation$ = new BehaviorSubject<IUserGeolocation>(userGeolocation);

  }

  setUserGeolocation = (userGeoLocation: IUserGeolocation) => {

    this.store.dispatch(new AppStoreActions.Config.SetUserGeolocation({ userGeoLocation }));

    this.localStorage.set(LocalStorageKeysEnum.USER_LOCATION, userGeoLocation);


  }

  //setRemoveGeolocation = (userGeolocation: IUserGeolocation) => {

  removeGeolocation = () => {

    this.store.dispatch(new AppStoreActions.Config.SetUserGeolocation({ userGeoLocation: null }));
    this.localStorage.remove(LocalStorageKeysEnum.USER_LOCATION);

  }

  loadGeoLocationFromLocalStorage = () => {
    const userGeoLocation = this.localStorage.get<IUserGeolocation>(LocalStorageKeysEnum.USER_LOCATION);
    this.store.dispatch(new AppStoreActions.Config.SetUserGeolocation({ userGeoLocation }));
  }


}
